import { TypographyClassKey } from "@mui/material";
import { primaryPalette } from "./PaletteOverrides";

export const typographyOverrides: Partial<Record<TypographyClassKey, React.CSSProperties>> = {
  h1: {
    fontSize: 56,
    fontFamily: "KPMG !important",
    fontWeight: "bold",
  },
  h2: {
    fontSize: 36,
    fontWeight: "bold",
  },
  h3: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#858383",
  },
  h4: {
    fontSize: 22,
    fontWeight: "bold",
  },
  h5: {
    fontSize: 28,
    fontWeight: "bold",
  },
  h6: {
    fontSize: 16,
    color: primaryPalette.dark,
  },
  body2: {
    fontSize: 18,
    lineHeight: 1.2,
    color: "#4d4e50",
  },
  subtitle1: {
    fontSize: 18,
    color: primaryPalette.dark,
    fontWeight: "bold",
    marginTop: 6,
  },
  subtitle2: {
    fontSize: 18,
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "bold",
  },
  root: {
    fontFamily: "Arial",
  },
};
